









































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import Paragraph from "@/components/Text/Global/Paragraph.vue";
import Map from "@/components/Map/Map.vue";
import NavbarTitle from "@/components/Text/Navbar/NavbarTitle.vue";
import { store } from "@/store/store";
import { IMapDataDefinition, StateEnum } from "@/types/types";
import { PosteActionsTypes } from "@/store/modules/Poste/types";
import DeviceDescriptionTable from "@/components/Table/DeviceDescription/DeviceDescriptionTable.vue";
import { Device } from "@/store/modules/Device/interface";
import CardTitle from "@/components/Text/Card/CardTitle.vue";
import Utils from "@/utils/utils";
import { DeviceActionsTypes } from "@/store/modules/Device/types";
import { CameraImageActionsTypes } from "../../../../store/modules/CameraImage/types";
import { CameraImage, GetDevice } from "../../../../store/modules/CameraImage/interface";

interface DeviceDescriptionData {
  device: Device;
  map_should_be_displayed: boolean;
  map_classes: string;
  loading: boolean;
  actual_date: string;
  actual_time: string;
  actual_datas: CameraImage | null;
  cameras_data: Array<string>;
  selected: Array<string>;
  mount: boolean;
  cards_expand_button_style: string;
  card_class: string;
  text_class: string;
}

export default Vue.extend({
  name: "deviceDescription",
  components: { StandartCard, Paragraph, Map, NavbarTitle, DeviceDescriptionTable, CardTitle },
  async created() {
    const id = this.$route.query.deviceId as string;
    if (store.getters.DEVICE_BY_ID[id] === undefined) {
      await store.dispatch(DeviceActionsTypes.GET_DEVICE, id);
    }
    await store.dispatch(PosteActionsTypes.LIST_POSTE_BY_MATERIAL, id);
    await store.dispatch(CameraImageActionsTypes.GET_CAMERA_IMAGE, { id: id, number_devices: 30 } as GetDevice);
    this.cameras_data = store.getters.CAMERA_IMAGE_ALL_ID.filter(
      (camera_id) => store.getters.CAMERA_IMAGE_BY_ID[camera_id].material === (this.$route.query.deviceId as string)
    );
    this.loading = false;
    this.device = store.getters.DEVICE_BY_ID[this.$route.query.deviceId as string];
    this.selectDate();
    this.setImage();
    window.addEventListener("keydown", this.handleKeyDown);
    this.mount = true;
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  data(): DeviceDescriptionData {
    return {
      device: store.getters.DEVICE_BY_ID[this.$route.query.deviceId as string],
      map_should_be_displayed: false,
      map_classes: "map-display",
      loading: true,
      selected: [],
      actual_date: "",
      actual_time: "",
      actual_datas: null,
      cameras_data: store.getters.CAMERA_IMAGE_ALL_ID.filter(
        (camera_id) => store.getters.CAMERA_IMAGE_BY_ID[camera_id].material === (this.$route.query.deviceId as string)
      ),
      mount: false,
      cards_expand_button_style: "display_cog",
      card_class: "card-default",
      text_class: "pl-6 pr-6 text_default"
    };
  },
  methods: {
    expandCard(): void {
      this.cards_expand_button_style = this.cards_expand_button_style.includes("rotate-180")
        ? "display_cog rotate-0"
        : "display_cog rotate-180";
      this.card_class = this.card_class.includes("card-up") ? "card-down" : "card-up";
      this.text_class = this.text_class.includes("text-up") ? "pl-6 pr-6 text-down" : "pl-6 pr-6 text-up";
    },
    handleKeyDown(event: KeyboardEvent): void {
      switch (event.key) {
        case "ArrowRight":
          this.nextImage();
          break;

        case "ArrowLeft":
          this.previousImage();
          break;

        default:
          break;
      }
    },
    formattedDate(date: string | Date): string {
      return Utils.transformDateToYMDHMS(date);
    },
    mapDisplayToggle(): void {
      this.map_should_be_displayed = !this.map_should_be_displayed;
    },
    clearSelected(): void {
      this.selected = [];
    },
    onSelectChange(_ids: Array<string>): void {
      this.selected = _ids;
    },
    previousImage(): void {
      const times = this.selectTime();
      const index = times.findIndex((time) => time === this.actual_time);
      if (index !== -1 && index > 0) {
        this.actual_time = times[index - 1];
      }
      if (index === 0) {
        const dates = this.selectDate();
        const date_index = dates.findIndex((date) => date === this.actual_date);
        if (date_index !== -1 && date_index > 0) {
          this.actual_date = dates[date_index - 1];
          const new_time = this.selectTime();
          this.actual_time = new_time[new_time.length - 1];
        }
      }
    },
    nextImage(): void {
      const times = this.selectTime();
      const index = times.findIndex((time) => time === this.actual_time);
      if (index !== -1 && index < times.length - 1) {
        this.actual_time = times[index + 1];
      }
      if (index === times.length - 1) {
        const dates = this.selectDate();
        const date_index = dates.findIndex((date) => date === this.actual_date);
        if (date_index !== -1 && date_index < dates.length - 1) {
          this.actual_date = dates[date_index + 1];
          const new_time = this.selectTime();
          this.actual_time = new_time[0];
        }
      }
    },
    selectDate(): Array<string> {
      const dates: Array<string> = [];
      this.cameras_data.forEach((camera_id) => {
        const date = Utils.transformDateToYMD(store.getters.CAMERA_IMAGE_BY_ID[camera_id].date);
        if (dates.indexOf(date) === -1) {
          dates.push(date);
        }
      });
      if (this.actual_date.length === 0) {
        this.actual_date = dates[0];
      }
      if (this.actual_time.length === 0) {
        const times = this.selectTime();
        this.actual_time = times[times.length - 1];
      }
      dates.sort();
      return dates;
    },
    selectTime(): Array<string> {
      const times: Array<string> = [];
      this.cameras_data.forEach((camera_id) => {
        const date = Utils.transformDateToYMD(store.getters.CAMERA_IMAGE_BY_ID[camera_id].date);
        if (date === this.actual_date) {
          const time = Utils.transformDateToHMS(store.getters.CAMERA_IMAGE_BY_ID[camera_id].date);
          if (times.indexOf(time) === -1) {
            times.push(time);
          }
        }
      });
      times.sort();
      return times;
    },
    changeTime(time: string) {
      this.actual_time = time;
    },
    changeDate(date: string) {
      this.actual_date = date;
      this.actual_time = this.selectTime()[0];
    },
    setImage(): void {
      const camera_id = this.cameras_data.find((camera_id_: string) => {
        const date = Utils.transformDateToYMD(store.getters.CAMERA_IMAGE_BY_ID[camera_id_].date);
        const time = Utils.transformDateToHMS(store.getters.CAMERA_IMAGE_BY_ID[camera_id_].date);
        return date === this.actual_date && time === this.actual_time;
      });
      this.actual_datas = store.getters.CAMERA_IMAGE_BY_ID[camera_id as string];
    },
    displayImage(): string {
      this.setImage();
      return `${process.env.VUE_APP_API}/public/images/${(this.actual_datas as CameraImage).filepath}`;
    }
  },
  computed: {
    displayAgence(): string {
      return store.getters.AGENCE_BY_ID[this.device.agence].name;
    },
    displayState(): string {
      return store.getters.STATE_BY_ID[this.device.state].name;
    },
    displayCategory(): string {
      return store.getters.CATEGORY_BY_ID[this.device.category].name;
    },
    displayResolution(): string {
      const resolution = store.getters.CAMERA_RESOLUTION_BY_ID[this.device.resolution];
      return resolution ? `${resolution.name} - ${resolution.resolution} - ${resolution.format}` : "N/A";
    },
    displayDisponibility(): string {
      return store.getters.STATE_BY_ID[this.device.state].name === StateEnum.RESERVE_DISP
        ? "Disponible"
        : "Non Disponible";
    },
    mapDatas(): Array<IMapDataDefinition> {
      if (this.selected.length === 0) {
        return [
          {
            name: this.device.material_name,
            comment: this.device.comment || "",
            location: this.device.location
          }
        ];
      } else {
        return this.selected.map((poste_id) => {
          const poste = store.getters.POSTE_BY_ID[poste_id];
          return {
            name: `${poste.name_poste} | ${store.getters.SURVEY_BY_ID[poste.survey].name_survey}`,
            comment: poste.comment,
            location: poste.real_location
          };
        });
      }
    },
    updatedDate(): string {
      return Utils.transformDateToYMD(this.device.updated);
    },
    remplissageStyle(): any {
      const actual_remplissage = (this.actual_datas as CameraImage)?.remplissage;
      if (actual_remplissage >= 70) {
        return { color: "var(--alyce-orange)" };
      } else if (actual_remplissage >= 90) {
        return { color: "var(--button-no-color)" };
      } else {
        return { color: "var(--button-yes-color)" };
      }
    },
    calculate_battery_level(): number {
      const tension_max = 12.6;
      try {
        const tension_number = parseFloat((this.actual_datas as CameraImage)?.tension.split("V")[0]);
        if (isNaN(tension_number)) return -1;
        if (tension_number <= 9) return 0;
        return Math.round(((tension_number - 9) / (tension_max - 9)) * 100);
      } catch (e) {
        return -1;
      }
    },
    defineBatteryColor(): any {
      const actual_battery = this.calculate_battery_level;
      switch (true) {
        case actual_battery >= 30:
          return {
            color: "var(--button-yes-color)"
          };
        case actual_battery >= 15 && actual_battery < 30:
          return {
            color: "var(--alyce-orange)"
          };
        case actual_battery >= 1 && actual_battery < 15:
          return {
            color: "var(--button-no-color)"
          };
        default:
          return {};
      }
    }
  },
  watch: {
    map_should_be_displayed(): void {
      if (this.map_should_be_displayed) this.map_classes = "map-display map-display-up";
      else this.map_classes = "map-display map-display-down";
    }
  }
});
